(function (angular) {
    "use strict";
    angular.module('smartpublic.config', []);
})(angular);